module.exports = __webpack_public_path__ + "static/media/peaPhoto.95edd001.jpg";